export default __webpack_public_path__ + "static/media/element_spec_26.c54b13fb.jpg";